import { render } from "./StorePassenger.vue?vue&type=template&id=78bdcae2&scoped=true"
import script from "./StorePassenger.vue?vue&type=script&lang=js"
export * from "./StorePassenger.vue?vue&type=script&lang=js"

import "./StorePassenger.vue?vue&type=style&index=0&id=78bdcae2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78bdcae2"

export default script